<app-header></app-header>
<ion-content>
  <ng-container *ngIf="(platformService?.isTouchExperience$ | async) === false">
    <div
      *ngFor="let experience of (deliveriesViewModel$ | async)?.experiences; trackBy: trackByIndex"
    >
      <div class="product-carousel" *ngIf="experience?.products?.length > 0">
        <app-merchandising-product-carousel
          [platformType]="platformService?.platformType"
          [title]="experienceToTitleMap[experience?.name]"
          [products]="experience?.products"
          (quantityUpdateEmitter)="onQuantityUpdate($event.quantityUpdate)"
          [linkSource]="linkSource"
        >
        </app-merchandising-product-carousel>
      </div>
    </div>
  </ng-container>
</ion-content>
